import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { Entities } from 'src/enums'
import { DisconnectSensorPayload } from 'src/api'
import { useApiInstance } from './useApiInstance'

interface RequestParams {
  uniqueId: string
  options?: Omit<UseMutationOptions<unknown, Error, DisconnectSensorPayload, boolean>, 'mutationKey' | 'mutationFn'>
}

export const useSensorDisconnecting = ({ uniqueId, options }: RequestParams) => {
  const api = useApiInstance()

  return useMutation<unknown, Error, DisconnectSensorPayload, boolean>(
    [Entities.Sensors, 'disconnect', uniqueId],
    async (payload: DisconnectSensorPayload) => {
      const { data } = await api.v1AdminSensorsUniqueIdDisconnectPost(uniqueId, payload)
      return data
    },
    {
      ...options
    }
  )
}
